import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}level/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                levels: response.data.levels,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'level/get-by-id?id=' + id,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                level: response.data.level
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

//create a function to send the name and image to axios post to save the level
const Add = async (name, image, sequence, referCount, giftId) => {
    try {
        const data = new FormData();
        data.append("name", name);
        data.append("image", image);
        data.append("sequence", sequence);
        data.append("referCount", referCount);
        data.append("giftId", giftId);

        console.log("Image in service : " + image);

        console.log("Data in service : " + data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'level/add', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("Level added successfully");
            return {
                status: 200,
                message: response.data.message,
                level: response.data.level
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message

        };
    }
}

const Update = async (id, name, image, sequence, referCount, giftId, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("image", image);
        data.append("sequence", sequence);
        data.append("referCount", referCount);
        data.append("giftId", giftId);
        data.append("status", status);

        console.log("Image in service : " + image);

        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'level/update', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                level: response.data.level
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}

export { Add, Update, GetById, GetAll };
